(function($){

    'use strict';

    class FooterSection extends HTMLElement {
        constructor() {
            super();
            
            theme.AssetsLoader.onScrollOrUserAction(this, () => {
                this.load();
            });
        }

        load() {
            this.$container = $(this);
            this.namespace = '.footer';

            this.buttonToTopInit(this.namespace);
            this.fixedFooter(this.$container.find('.js-footer'), this.namespace);
            this.currencyInit();
        }

        currencyInit() {
            this.$currencies_form = $('.js-currencies-form');

            this.$currencies_form.find('select').on('change', function() {
                $(this).parents('form').find('[name="country_code"]').val(this.value);
                $(this).parents('form').submit();
            });
        }

        buttonToTopInit(namespace) {
            var _ = this,
                $button = $('[data-js-button-back-to-top]'),
                namespace = namespace + '.buttonToTop';

            if(!$button.length) {
                return;
            }

            var bp = $button.attr('data-js-button-back-to-top') || 1000,
                duration = function () {
                    return theme.animations.backtotop.scroll_duration * 1000;
                },
                unbind = true;

            this.is_animate = false;

            $window.on('scroll' + namespace + ' theme.resize' + namespace, function () {
                var scroll_t = pageYOffset || Math.max($('body').scrollTop(), $('html').scrollTop());

                if(!$button.attr('data-bind')) {
                    $button[scroll_t > bp ? 'addClass' : 'removeClass']('show');
                }

                if(scroll_t > bp && unbind) {
                    $button.removeAttr('data-bind');
                }
            });

            $button.on('click', function(e) {
                if(_.is_animate) return;

                _.is_animate = true;

                var bind = $button.attr('data-bind');

                if(bind) {
                    $('html, body').stop().animate({
                        scrollTop: bind,
                        duration: duration()
                    });

                    setTimeout(() => {
                        _.is_animate = false;
                        $button.removeAttr('data-bind');
                    }, duration());
                } else {
                    var scroll_t = pageYOffset || Math.max($('body').scrollTop(), $('html').scrollTop());

                    unbind = false;

                    $button.attr('data-bind', scroll_t);

                    $('html, body').stop().animate({
                        scrollTop: 0,
                        duration: duration()
                    });

                    setTimeout(() => {
                        _.is_animate = false;
                        unbind = true;
                    }, duration());
                }
                

                e.preventDefault();
                e.stopPropagation();
                return false;
            });

            this.$buttonToTop = $button;
        }

        fixedFooter($footer, namespace) {
            if(!$footer.length || !$footer[0].hasAttribute('data-js-footer-fixed')) {
                return;
            }

            var $parent = $footer.parent(),
                $main = $('#MainContent');

            function calculate() {
                var footer_height = $footer.outerHeight(),
                    can_fix = $main.innerHeight() > footer_height + window.innerHeight;

                $footer[can_fix && theme.current.is_desktop ? 'addClass' : 'removeClass']('footer--fixed');

                $footer.css({
                    width: theme.current.is_desktop && $parent.hasClass('container') ? $parent.width() : ''
                });

                $main.css({
                    marginBottom: can_fix && theme.current.is_desktop ? footer_height + parseInt($footer.css('margin-top')) : ''
                });
            };

            $window.on('theme.resize' + namespace + ' scroll' + namespace, calculate);

            calculate();
        }

        disconnectedCallback() {
            if(this.$buttonToTop) $buttonToTop.off();

            $window.unbind('theme.resize' + namespace + ' scroll' + namespace);
        }
    }

    theme.AssetsLoader.onPageLoaded(function() {
        customElements.define('footer-section', FooterSection);
    });
  function removeSingleVariant(){

if( window.location.href.indexOf("collection") > -1) {
$('.collection-filters__checkbox').each(function(i, obj) {

  

 if($(this).html().indexOf('<span>Gold</span>') != -1){
  $(this).html($(this).html().replace('<span>Gold</span>','<img src="https://cdn.shopify.com/s/files/1/0401/8425/0518/files/Gold-Swatch_430x.png?v=1687351443" alt="Gold" width="30" height="30"/>'));

 }

  if($(this).html().indexOf('<span>Silver</span>') != -1){
  $(this).html($(this).html().replace('<span>Gold</span>','<img src="https://cdn.shopify.com/s/files/1/0401/8425/0518/files/Silver-Swatch_430x.png?v=1687351443" alt="Silver" width="30" height="30"/>'));

 }

  if($(this).html().indexOf('<span>Rose Gold</span>') != -1){
  $(this).html($(this).html().replace('<span>Gold</span>','<img src="https://cdn.shopify.com/s/files/1/0401/8425/0518/files/Rose-Gold-Swatch_430x.png?v=1687351443" alt="Rose-Gold" width="30" height="30"/>'));

 }
 

  
});
}
    

   if( window.location.href.indexOf("collection") > -1) {
 if ($('.collection-filters__checkbox :contains("14kt Rose Gold-Plated Sterling Silver")').length > 0) {

  var rose = $('.collection-filters__checkbox :contains("14kt Rose Gold-Plated Sterling Silver")').parent();
  var rosep = $('.collection-filters__checkbox :contains("14kt Rose Gold-Plated Sterling Silver")').parent().parent();
$(rose).remove();
$(rosep).append(rose);
      
  
}
   }
    var countfiltesr = $('[name="filter.p.product_type"]').length;
if(countfiltesr == 1){
//$('.collection-sidebar-section').hide();
$("[data-index='section-filters-1']").hide();
}  
var $options = document.querySelectorAll(`.product-page-info__variants select > option`);
  
if (!$options){

return;
}

 
if( window.location.href.indexOf("collections") > -1 || window.location.href.indexOf("search") > -1){

$(window).on('scroll', function(){
  $('.product-collection__wrapper').not('.donealternates').each(function(i, select){
      $(this).addClass('donealternates');
    
var thistitle = $(this).find('h4').text();
var linkedproduct = $(this).find('.linkedproduct').text();
var linkedproductb = $(this).find('.linkedproduct2').text();
var doublecheck = 0;
if(linkedproduct.indexOf("mother-of") >0 &&   (linkedproductb.indexOf("mother-of") >0 || thistitle.indexOf("Mother Of") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("turquoise") >0 &&   (linkedproductb.indexOf("turquoise") >0 || thistitle.indexOf("Turquoise") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("lapis") >0 &&   (linkedproductb.indexOf("lapis") >0 || thistitle.indexOf("Lapis") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("pearl") >0 &&   (linkedproductb.indexOf("pearl") >0 || thistitle.indexOf("Pearl") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("abalone") >0 &&   (linkedproductb.indexOf("abalone") >0  || thistitle.indexOf("Abalone") >0)){doublecheck=1;}  
if(linkedproduct.indexOf("malachite") >0 &&   (linkedproductb.indexOf("malachite") >0 || thistitle.indexOf("Malachite") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("amazonite") >0 &&   (linkedproductb.indexOf("amazonite") >0 || thistitle.indexOf("Amazonite") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("rose-quartz") >0 &&  ( linkedproductb.indexOf("rose-quartz") >0 || thistitle.indexOf("Rose Quartz") >0) ){doublecheck=1;}
 var links = '<p style="clear:both;text-align:center">';
if(linkedproduct != ''){
    if(doublecheck == 0 && thistitle.indexOf("Mother Of Pearl") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring mop" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Turquoise") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring tq" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Lapis") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring la" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Pearl") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring pe" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Abalone") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring ab" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Malachite") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring ma" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Amazonite") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring am" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Rose Quartz") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring rq" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(thistitle.indexOf("Rose") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring rgpss" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(thistitle.indexOf("Silver") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring rpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(thistitle.indexOf("Gold") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring gpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';}
    
      if(doublecheck == 0 && linkedproduct.indexOf('mother-of') !== -1){ // SHOW MOP
       links = links + '<a href="'+linkedproduct+'"><label class="newring mop" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(doublecheck == 0 && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
        else if(doublecheck == 0 && linkedproduct.indexOf('lapis') !== -1){ // SHOW Lapis
       links = links + '<a href="'+linkedproduct+'"><label class="newring la" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('pearl') !== -1){ // SHOW pearl
       links = links + '<a href="'+linkedproduct+'"><label class="newring pe" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('abalone') !== -1){ // SHOW Abalone
       links = links + '<a href="'+linkedproduct+'"><label class="newring ab" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
         else if(doublecheck == 0 && linkedproduct.indexOf('malachite') !== -1){ // SHOW Malachite
       links = links + '<a href="'+linkedproduct+'"><label class="newring ma" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('amazonite') !== -1){ // SHOW Amazonite
       links = links + '<a href="'+linkedproduct+'"><label class="newring am" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
          else if(doublecheck == 0 && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
             else if(doublecheck == 0 && linkedproduct.indexOf('rose-qua') !== -1){ // SHOW Rose Q
       links = links + '<a href="'+linkedproduct+'"><label class="newring rq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('silver') !== -1){ // SHOW SILVER
       links = links + '<a href="'+linkedproduct+'"><label class="newring rpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('rose') !== -1){ // SHOW GOLD
       links = links + '<a href="'+linkedproduct+'"><label class="newring rgpss" for="newring_42457031835798" style="margin-left:5px; margin-right:5px"  ></label></a>';
      } 
      else {
      links = links + '<a href="'+linkedproduct+'"><label class="newring gpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      }
 $(this).find('.linkedproductshow').html(links+'</p>').css('display','block');
       
     }
var linkedproduct = $(this).find('.linkedproduct2').text();

  if(linkedproduct != ''){
    
     if(doublecheck == 0 && linkedproduct.indexOf('mother-of') !== -1){ // SHOW MOP
       links = links + '<a href="'+linkedproduct+'"><label class="newring mop" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(doublecheck == 0 && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
        else if(doublecheck == 0 && linkedproduct.indexOf('lapis') !== -1){ // SHOW Lapis
       links = links + '<a href="'+linkedproduct+'"><label class="newring la" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('pearl') !== -1){ // SHOW pearl
       links = links + '<a href="'+linkedproduct+'"><label class="newring pe" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('abalone') !== -1){ // SHOW Abalone
       links = links + '<a href="'+linkedproduct+'"><label class="newring ab" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
         else if(doublecheck == 0 && linkedproduct.indexOf('malachite') !== -1){ // SHOW Malachite
       links = links + '<a href="'+linkedproduct+'"><label class="newring ma" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('amazonite') !== -1){ // SHOW Amazonite
       links = links + '<a href="'+linkedproduct+'"><label class="newring am" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
          else if(doublecheck == 0 && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
             else if(doublecheck == 0 && linkedproduct.indexOf('rose-qua') !== -1){ // SHOW Rose Q
       links = links + '<a href="'+linkedproduct+'"><label class="newring rq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('silver') !== -1){ // SHOW SILVER
       links = links + '<a href="'+linkedproduct+'"><label class="newring rpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('rose') !== -1){ // SHOW GOLD
       links = links + '<a href="'+linkedproduct+'"><label class="newring rgpss" for="newring_42457031835798" style="margin-left:5px; margin-right:5px"  ></label></a>';
      } 
      else {
      links = links + '<a href="'+linkedproduct+'"><label class="newring gpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      }
  $(this).find('.linkedproductshow').html(links+'</p>').css('display','block');
       
     }
  
});
});
  
$('.product-collection__wrapper').each(function(i, select){
  $(this).addClass('donealternates');
var thistitle = $(this).find('h4').text();
var linkedproduct = $(this).find('.linkedproduct').text();
var linkedproductb = $(this).find('.linkedproduct2').text();
var doublecheck = 0;
if(linkedproduct.indexOf("mother-of") >0 &&   (linkedproductb.indexOf("Mother Of Pearl") >0 || thistitle.indexOf("mother-of") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("turquoise") >0 &&   (linkedproductb.indexOf("turquoise") >0 || thistitle.indexOf("turquoise") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("lapis") >0 &&   (linkedproductb.indexOf("lapis") >0 || thistitle.indexOf("lapis") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("pearl") >0 &&   (linkedproductb.indexOf("pearl") >0 || thistitle.indexOf("pearl") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("abalone") >0 &&   (linkedproductb.indexOf("abalone") >0  || thistitle.indexOf("abalone") >0)){doublecheck=1;}  
if(linkedproduct.indexOf("malachite") >0 &&   (linkedproductb.indexOf("malachite") >0 || thistitle.indexOf("malachite") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("amazonite") >0 &&   (linkedproductb.indexOf("amazonite") >0 || thistitle.indexOf("amazonite") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("rose-quartz") >0 &&  ( linkedproductb.indexOf("rose-quartz") >0 || thistitle.indexOf("rose-quartz") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("mother-of") >0 &&   (linkedproductb.indexOf("mother-of") >0 || thistitle.indexOf("Mother Of") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("turquoise") >0 &&   (linkedproductb.indexOf("turquoise") >0 || thistitle.indexOf("Turquoise") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("lapis") >0 &&   (linkedproductb.indexOf("lapis") >0 || thistitle.indexOf("Lapis") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("pearl") >0 &&   (linkedproductb.indexOf("pearl") >0 || thistitle.indexOf("Pearl") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("abalone") >0 &&   (linkedproductb.indexOf("abalone") >0  || thistitle.indexOf("Abalone") >0)){doublecheck=1;}  
if(linkedproduct.indexOf("malachite") >0 &&   (linkedproductb.indexOf("malachite") >0 || thistitle.indexOf("Malachite") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("amazonite") >0 &&   (linkedproductb.indexOf("amazonite") >0 || thistitle.indexOf("Amazonite") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("rose-quartz") >0 &&  ( linkedproductb.indexOf("rose-quartz") >0 || thistitle.indexOf("Rose Quartz") >0) ){doublecheck=1;}
if(linkedproduct != ''){
     var links = '<p style="clear:both;text-align:center">';
   if(doublecheck == 0 && thistitle.indexOf("Mother Of Pearl") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring mop" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Turquoise") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring tq" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Lapis") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring la" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Pearl") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring pe" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Abalone") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring ab" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Malachite") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring ma" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Amazonite") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring am" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(doublecheck == 0 && thistitle.indexOf("Rose Quartz") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring rq" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(thistitle.indexOf("Rose") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring rgpss" for="newring_42457031835798" style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(thistitle.indexOf("Silver") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring rpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';}
    else if(thistitle.indexOf("Gold") >0){links = '<a href="'+$(this).find('a.cursor-default').attr('href')+'"><label class="newring gpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';}
    
      if(doublecheck == 0 && linkedproduct.indexOf('mother-of') !== -1){ // SHOW MOP
       links = links + '<a href="'+linkedproduct+'"><label class="newring mop" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(doublecheck == 0 && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
        else if(doublecheck == 0 && linkedproduct.indexOf('lapis') !== -1){ // SHOW Lapis
       links = links + '<a href="'+linkedproduct+'"><label class="newring la" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('pearl') !== -1){ // SHOW pearl
       links = links + '<a href="'+linkedproduct+'"><label class="newring pe" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('abalone') !== -1){ // SHOW Abalone
       links = links + '<a href="'+linkedproduct+'"><label class="newring ab" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
         else if(doublecheck == 0 && linkedproduct.indexOf('malachite') !== -1){ // SHOW Malachite
       links = links + '<a href="'+linkedproduct+'"><label class="newring ma" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('amazonite') !== -1){ // SHOW Amazonite
       links = links + '<a href="'+linkedproduct+'"><label class="newring am" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
          else if(doublecheck == 0 && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
             else if(doublecheck == 0 && linkedproduct.indexOf('rose-qua') !== -1){ // SHOW Rose Q
       links = links + '<a href="'+linkedproduct+'"><label class="newring rq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('silver') !== -1){ // SHOW SILVER
       links = links + '<a href="'+linkedproduct+'"><label class="newring rpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('rose') !== -1){ // SHOW GOLD
       links = links + '<a href="'+linkedproduct+'"><label class="newring rgpss" for="newring_42457031835798" style="margin-left:5px; margin-right:5px"  ></label></a>';
      } 
      else {
      links = links + '<a href="'+linkedproduct+'"><label class="newring gpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      }
 $(this).find('.linkedproduct').html(links+'</p>').css('display','block');
       
     }
var linkedproduct = $('#linkedproduct2').text();
  if(linkedproduct != ''){
    
     if(doublecheck == 0 && linkedproduct.indexOf('mother-of') !== -1){ // SHOW MOP
       links = links + '<a href="'+linkedproduct+'"><label class="newring mop" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(doublecheck == 0 && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
        else if(doublecheck == 0 && linkedproduct.indexOf('lapis') !== -1){ // SHOW Lapis
       links = links + '<a href="'+linkedproduct+'"><label class="newring la" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('pearl') !== -1){ // SHOW pearl
       links = links + '<a href="'+linkedproduct+'"><label class="newring pe" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('abalone') !== -1){ // SHOW Abalone
       links = links + '<a href="'+linkedproduct+'"><label class="newring ab" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
         else if(doublecheck == 0 && linkedproduct.indexOf('malachite') !== -1){ // SHOW Malachite
       links = links + '<a href="'+linkedproduct+'"><label class="newring ma" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('amazonite') !== -1){ // SHOW Amazonite
       links = links + '<a href="'+linkedproduct+'"><label class="newring am" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
          else if(doublecheck == 0 && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
             else if(doublecheck == 0 && linkedproduct.indexOf('rose-qua') !== -1){ // SHOW Rose Q
       links = links + '<a href="'+linkedproduct+'"><label class="newring rq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('silver') !== -1){ // SHOW SILVER
       links = links + '<a href="'+linkedproduct+'"><label class="newring rpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('rose') !== -1){ // SHOW GOLD
       links = links + '<a href="'+linkedproduct+'"><label class="newring rgpss" for="newring_42457031835798" style="margin-left:5px; margin-right:5px"  ></label></a>';
      } 
      else {
      links = links + '<a href="'+linkedproduct+'"><label class="newring gpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      }
  $(this).find('.linkedproduct').html(links+'</p>').css('display','block');
       
     }
  
});

}

 if( window.location.href.indexOf("product") > -1){

  var linkedproduct = $('#linkedproduct').text();
   var linkedproductb = $(this).find('.linkedproduct2').text();
var doublecheck = 0;
if(linkedproduct.indexOf("mother-of") >0 &&   (linkedproductb.indexOf("Mother Of Pearl") >0 || window.location.href.indexOf("mother-of") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("turquoise") >0 &&   (linkedproductb.indexOf("turquoise") >0 || window.location.href.indexOf("turquoise") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("lapis") >0 &&   (linkedproductb.indexOf("lapis") >0 || window.location.href.indexOf("lapis") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("pearl") >0 &&   (linkedproductb.indexOf("pearl") >0 || window.location.href.indexOf("pearl") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("abalone") >0 &&   (linkedproductb.indexOf("abalone") >0  || window.location.href.indexOf("abalone") >0)){doublecheck=1;}  
if(linkedproduct.indexOf("malachite") >0 &&   (linkedproductb.indexOf("malachite") >0 || window.location.href.indexOf("malachite") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("amazonite") >0 &&   (linkedproductb.indexOf("amazonite") >0 || window.location.href.indexOf("amazonite") >0) ){doublecheck=1;}  
if(linkedproduct.indexOf("rose-quartz") >0 &&  ( linkedproductb.indexOf("rose-quartz") >0 || window.location.href.indexOf("rose-quartz") >0) ){doublecheck=1;}  
  if(linkedproduct != ''){
    console.log(doublecheck);
     var links = '';
    if(doublecheck == 0 && window.location.href.indexOf("mother-of") >0){links = '<a class="current"><label class="newring mop" for="newring_42457031835798" ></label></a>';}
    else if(doublecheck == 0 && window.location.href.indexOf("turquoise") >0){links = '<a class="current"><label class="newring tq" for="newring_42457031835798" ></label></a>';}
    else if(doublecheck == 0 && window.location.href.indexOf("lapis") >0){links = '<a class="current"><label class="newring la" for="newring_42457031835798" ></label></a>';}
    else if(doublecheck == 0 && window.location.href.indexOf("pearl") >0){links = '<a class="current"><label class="newring pe" for="newring_42457031835798" ></label></a>';}
    else if(doublecheck == 0 && window.location.href.indexOf("abalone") >0){links = '<a class="current"><label class="newring ab" for="newring_42457031835798" ></label></a>';}
    else if(doublecheck == 0 && window.location.href.indexOf("malachite") >0){links = '<a class="current"><label class="newring ma" for="newring_42457031835798" ></label></a>';}
    else if(doublecheck == 0 && window.location.href.indexOf("amazonite") >0){links = '<a class="current"><label class="newring am" for="newring_42457031835798" ></label></a>';}
    else if(doublecheck == 0 && window.location.href.indexOf("rose-qua") >0){links = '<a class="current"><label class="newring rq" for="newring_42457031835798" ></label></a>';}

    else if(window.location.href.indexOf("rose") >0){links = '<a class="current"><label class="newring rgpss" for="newring_42457031835798" ></label></a>';}
    else if(window.location.href.indexOf("silver") >0){links = '<a class="current"><label class="newring rpss" for="newring_42457031835798" ></label></a>';}
    else if(window.location.href.indexOf("gold") >0){links = '<a class="current"><label class="newring gpss" for="newring_42457031835798" ></label></a>';}
    
      if(doublecheck == 0  && linkedproduct.indexOf('mother-of') !== -1){ // SHOW MOP
       links = links + '<a href="'+linkedproduct+'"><label class="newring mop" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(doublecheck == 0  && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
        else if(doublecheck == 0 && linkedproduct.indexOf('lapis') !== -1){ // SHOW Lapis
       links = links + '<a href="'+linkedproduct+'"><label class="newring la" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('pearl') !== -1){ // SHOW pearl
       links = links + '<a href="'+linkedproduct+'"><label class="newring pe" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('abalone') !== -1){ // SHOW Abalone
       links = links + '<a href="'+linkedproduct+'"><label class="newring ab" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
         else if(doublecheck == 0 && linkedproduct.indexOf('malachite') !== -1){ // SHOW Malachite
       links = links + '<a href="'+linkedproduct+'"><label class="newring ma" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('amazonite') !== -1){ // SHOW Amazonite
       links = links + '<a href="'+linkedproduct+'"><label class="newring am" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
          else if(doublecheck == 0 && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
             else if(doublecheck == 0 && linkedproduct.indexOf('rose-qua') !== -1){ // SHOW Rose Q
       links = links + '<a href="'+linkedproduct+'"><label class="newring rq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('silver') !== -1){ // SHOW SILVER
       links = links + '<a href="'+linkedproduct+'"><label class="newring rpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('rose') !== -1){ // SHOW GOLD
       links = links + '<a href="'+linkedproduct+'"><label class="newring rgpss" for="newring_42457031835798" style="margin-left:5px; margin-right:5px"  ></label></a>';
      } 
      else {
      links = links + '<a href="'+linkedproduct+'"><label class="newring gpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      }
  $('#linkedproduct').html(links).css('display','block');
       
     }
var linkedproduct = $('#linkedproduct2').text();
  if(linkedproduct != ''){
        

     if(doublecheck == 0 && linkedproduct.indexOf('mother-of') !== -1){ // SHOW MOP
       links = links + '<a href="'+linkedproduct+'"><label class="newring mop" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(doublecheck == 0 && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
        else if(doublecheck == 0 && linkedproduct.indexOf('lapis') !== -1){ // SHOW Lapis
       links = links + '<a href="'+linkedproduct+'"><label class="newring la" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('pearl') !== -1){ // SHOW pearl
       links = links + '<a href="'+linkedproduct+'"><label class="newring pe" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('abalone') !== -1){ // SHOW Abalone
       links = links + '<a href="'+linkedproduct+'"><label class="newring ab" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
         else if(doublecheck == 0 && linkedproduct.indexOf('malachite') !== -1){ // SHOW Malachite
       links = links + '<a href="'+linkedproduct+'"><label class="newring ma" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
       else if(doublecheck == 0 && linkedproduct.indexOf('amazonite') !== -1){ // SHOW Amazonite
       links = links + '<a href="'+linkedproduct+'"><label class="newring am" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
          else if(doublecheck == 0 && linkedproduct.indexOf('turquoise') !== -1){ // SHOW Turquoise
       links = links + '<a href="'+linkedproduct+'"><label class="newring tq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
             else if(doublecheck == 0 && linkedproduct.indexOf('rose-qua') !== -1){ // SHOW Rose Q
       links = links + '<a href="'+linkedproduct+'"><label class="newring rq" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('silver') !== -1){ // SHOW SILVER
       links = links + '<a href="'+linkedproduct+'"><label class="newring rpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      } 
      else if(linkedproduct.indexOf('rose') !== -1){ // SHOW GOLD
       links = links + '<a href="'+linkedproduct+'"><label class="newring rgpss" for="newring_42457031835798" style="margin-left:5px; margin-right:5px"  ></label></a>';
      } 
      else {
      links = links + '<a href="'+linkedproduct+'"><label class="newring gpss" for="newring_42457031835798"  style="margin-left:5px; margin-right:5px" ></label></a>';
      }
  $('#linkedproduct').html(links).css('display','block');
       
     }
   
  
   
if ($options.length <= 1 && window.location.href.indexOf("ring") <0){
var $option = document.querySelector(`.product-page-info__variants`);
$option.style.display = "none";
} else if ($options.length <= 1 && window.location.href.indexOf("earring") >0){
var $option = document.querySelector(`.product-page-info__variants`);
$option.style.display = "none";
} 

else {
var $option = document.querySelector(`.product-page-info__variants`);
$option.style.display = "none";
 
$('.product-page-info__variants select').each(function(i, select){
 
    var $select = $(select);
    $select.find('option').each(function(j, option){
        var $option = $(option);
       if($option.text().indexOf('Default') !== -1){ // DO NOTHING
       } else {
        // Create a radio:
        var $radio = $('<input type="radio" class="newring" />');
        // Set name and value:
        $radio.attr('name', $select.attr('name')).attr('value', $option.val()).attr('id', 'newring_'+$option.val());
        // Set checked if the option was selected
        if ($option.attr('selected')) $radio.attr('checked', 'checked');
        // Insert radio before select box:
       // $radio.andSelf().wrapAll('<label class="newring">');
        $select.before($radio);
        // Insert a label:
var classes = 'newring ';
  if($option.text().indexOf('14kt Gold-Plated Sterling Silver') !== -1){ var classes = 'newring gpss'}
  if($option.text().indexOf('Rhodium-Plated Sterling Silver') !== -1){ var classes = 'newring rpss'}
  if($option.text().indexOf('14kt Rose Gold-Plated Sterling Silver') !== -1){ var classes = 'newring rgpss'}
      
      
      $select.before(
          $("<label />").attr('class',classes).attr('for', 'newring_'+$option.val()).text($option.text().replace('#',''))
        );
        // Insert a <br />:
        //$select.before("<br/>");
       }
    });
    $select.remove();
});
    
  $option.style.display = "inline";
}
   
}
  }
if (window.location.href.indexOf("product") > -1 || window.location.href.indexOf("collection") > -1 || window.location.href.indexOf("search") > -1) {
removeSingleVariant();
}
if (window.location.href.indexOf("search")){
if ($('h2.h3:contains("No Results")').length > 0) {
    $(".showifempty").show();
   $(".collection-filters").hide();
} else {
 $(".showifempty").hide();
  
}
  
}
  
})(jQueryTheme);